import { render } from "./ProductAddEditForm.vue?vue&type=template&id=7879f7bd&scoped=true"
import script from "./ProductAddEditForm.vue?vue&type=script&lang=js"
export * from "./ProductAddEditForm.vue?vue&type=script&lang=js"

import "./ProductAddEditForm.vue?vue&type=style&index=0&id=7879f7bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7879f7bd"]])

export default __exports__